var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoucrm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 69,
    viewBox: "0 0 240 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M232.007 2.23753H7.5362C4.77176 2.23753 2.53073 4.47893 2.53073 7.24383V61.3654C2.53073 64.1303 4.77176 66.3717 7.5362 66.3717H232.007C234.771 66.3717 237.012 64.1303 237.012 61.3654V7.24383C237.012 4.47893 234.771 2.23753 232.007 2.23753Z",
    fill: "url(#paint0_linear_1_259)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_259",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 236,
    height: 65
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M232.007 2H7.5362C4.77176 2 2.53073 4.24139 2.53073 7.0063V61.1279C2.53073 63.8928 4.77176 66.1342 7.5362 66.1342H232.007C234.771 66.1342 237.012 63.8928 237.012 61.1279V7.0063C237.012 4.24139 234.771 2 232.007 2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.3715 76.1851C51.3645 76.1851 70.0039 57.5425 70.0039 34.5457C70.0039 11.5489 51.3645 -7.09365 28.3715 -7.09365C5.37859 -7.09365 -13.2609 11.5489 -13.2609 34.5457C-13.2609 57.5425 5.37859 76.1851 28.3715 76.1851Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M232.007 2H7.5362C4.77176 2 2.53073 4.24139 2.53073 7.0063V61.1279C2.53073 63.8928 4.77176 66.1342 7.5362 66.1342H232.007C234.771 66.1342 237.012 63.8928 237.012 61.1279V7.0063C237.012 4.24139 234.771 2 232.007 2Z",
    stroke: "url(#paint1_linear_1_259)",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6106 53.0854C27.1513 53.0854 27.1322 53.588 26.7541 53.8177C26.199 53.7985 26.1416 53.2912 26.6106 53.0854Z",
    fill: "url(#paint2_linear_1_259)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5067 45.5042C38.1001 45.619 37.9374 46.0929 37.5067 46.2795C36.9133 46.1024 37.0617 45.7052 37.5067 45.5042Z",
    fill: "url(#paint3_linear_1_259)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2691 14.3082C14.762 14.3273 15.03 14.7772 14.4558 14.9926C13.848 15.1266 13.7428 14.5092 14.2691 14.3082Z",
    fill: "url(#paint4_linear_1_259)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5425 45.6238C19.1837 45.6047 19.265 46.1838 18.7865 46.4901C18.15 46.5045 18.0448 45.9206 18.5425 45.6238Z",
    fill: "url(#paint5_linear_1_259)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7138 53.8225C12.4555 53.7602 12.3311 55.2487 11.977 55.5359C11.307 55.6125 11.2305 54.1431 11.7138 53.8225Z",
    fill: "url(#paint6_linear_1_259)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5021 40.1628C40.0047 39.8565 40.4545 41.9433 38.9663 42.398C37.4397 42.5751 36.9564 40.4787 38.5021 40.1628ZM38.7509 40.7659C38.1767 40.9095 38.0858 41.6561 38.7509 41.7566C39.3299 41.5795 39.3587 40.9813 38.7509 40.7659Z",
    fill: "url(#paint7_linear_1_259)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7908 56.5506C51.1737 56.5218 51.5756 56.5506 51.9584 56.5506H55.9016C56.3609 56.5506 57.1936 56.3495 57.0835 57.0722C57.0213 57.1823 56.9591 57.211 56.8491 57.2589C56.16 57.2589 51.0923 57.3116 50.8865 57.2398C50.542 57.1249 50.3984 56.6941 50.7861 56.5506H50.7908Z",
    fill: "url(#paint8_linear_1_259)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4481 45.1117C29.386 45.0638 28.9601 48.7875 28.9601 49.6633C28.5917 50.1084 27.2326 51.4725 26.7541 51.8697C26.5531 51.8841 26.2516 51.7549 26.2564 51.5203C26.2612 51.2188 27.9169 49.6777 28.2423 49.3331V46.873C28.2376 46.3752 28.027 45.4659 28.4481 45.1117Z",
    fill: "url(#paint9_linear_1_259)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.599 11.3216C12.4555 11.1828 12.1684 12.7814 12.1684 13.3796V47.6101C12.1684 48.2514 12.3646 50.8455 11.977 51.2092C11.1491 51.3815 11.4458 49.4336 11.4458 48.8688V14.1694C11.4458 13.6142 11.2735 11.6949 11.599 11.3216Z",
    fill: "url(#paint10_linear_1_259)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44.412 48.8401C44.5412 48.8497 44.6321 48.8497 44.7374 48.9263C44.9097 49.1895 44.8283 55.6843 44.8283 56.5554C45.2111 56.5554 48.2977 56.4884 48.4795 56.5936C48.8241 56.7899 48.6327 57.2398 48.2738 57.2541C47.1779 57.2972 46.0581 57.2541 44.9623 57.2541H18.5425H15.9584C15.6665 57.2541 14.518 57.4408 14.4941 56.9574C14.4701 56.3926 15.3985 56.5458 15.7287 56.5458H44.1201V51.281C44.1201 50.5966 43.8425 49.1895 44.412 48.8305V48.8401Z",
    fill: "url(#paint11_linear_1_259)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0693 14.3082H34.3006C34.8317 14.3082 35.3677 14.2842 35.8989 14.3082C37.746 16.0599 39.5357 17.8834 41.3494 19.6686L43.7181 22.0138C44.077 22.368 44.5986 22.7126 44.8331 23.1721V30.1981C44.8331 30.8251 45.1346 34.0318 44.5316 34.0845C43.9334 34.1371 44.1296 32.6725 44.1296 32.3375V29.6477V23.6124H38.2533C35.1811 23.6172 35.3868 21.8415 35.3868 19.3815V14.9974C31.1087 14.9447 26.8259 14.9974 22.5478 14.9974H18.6812C18.3271 14.9926 16.9442 15.2127 16.9107 14.6575C16.8772 14.1119 18.5377 14.3129 18.8535 14.3129H22.0788L22.0693 14.3082ZM36.0711 15.5047C36.0951 16.0455 36.0711 16.5959 36.0711 17.1415V19.9414C36.0711 23.4736 36.8942 22.8945 39.8228 22.8945H42.2873C42.718 22.8993 43.1582 22.9184 43.5889 22.8945C43.1487 22.3824 42.4978 21.808 42.0097 21.3198L38.3681 17.7207C38.0188 17.3761 36.3439 15.6674 36.0711 15.5047Z",
    fill: "url(#paint12_linear_1_259)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6865 20.4296C58.701 20.3578 59.7107 20.9561 59.9212 22.0043C60.127 23.0381 59.3614 23.8469 58.8206 24.6271C59.1269 25.2062 58.9881 25.7327 58.6483 26.2543C57.8157 27.5274 56.7581 28.8724 55.8633 30.1359L46.9434 42.9244C46.5319 43.5083 46.0773 44.2933 45.6179 44.8006C45.2159 45.2409 44.6034 45.5042 44.144 45.8918C42.5696 47.208 41.0718 48.5673 39.5501 49.9361C39.3204 50.1515 38.3968 51.3767 38.0906 50.7833C38.0379 50.6875 40.4019 44.6474 40.7416 43.3073C41.1149 41.8188 41.2297 41.8811 42.1437 40.5984L50.1879 29.1021C51.2933 27.5131 52.3795 25.9145 53.5089 24.3399C54.4755 22.9902 54.1166 22.9375 55.6049 22.2388C56.2222 21.3294 56.5189 20.6498 57.6961 20.4248L57.6865 20.4296ZM55.5044 23.062C54.7483 23.4832 53.1739 26.0581 52.6093 26.8574L43.5745 39.8278C42.8472 40.8712 41.8853 41.8667 41.536 43.1111C40.957 45.1548 40.2583 47.1123 39.4161 49.0698C39.9616 48.6056 40.4928 48.0982 41.0048 47.6005C41.7992 46.8682 42.6223 46.1694 43.4788 45.5042C44.9719 44.3459 44.9479 44.5422 46.0438 42.9675L54.1453 31.3229C54.5282 30.7772 58.3373 25.4838 58.3182 25.2828C58.2607 24.7036 55.8585 23.0572 55.5044 23.062ZM57.6865 21.1475C56.9543 21.4251 56.6624 21.9851 56.2748 22.6265C56.8538 23.0476 57.4424 23.4497 58.0262 23.8565C58.1411 23.9331 58.2512 24.0144 58.3708 24.091C58.6914 23.4066 59.4379 22.8083 59.1556 21.9851C58.9498 21.3821 58.2942 21.0662 57.6865 21.1475Z",
    fill: "url(#paint13_linear_1_259)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5044 25.6321C56.6911 25.6178 55.2029 27.2834 54.978 27.6088L44.8762 42.1156C44.3833 42.8096 43.5506 44.5805 42.9046 44.4943C42.0145 44.0444 42.4835 42.5798 43.5985 42.6899C43.9287 42.2448 44.2301 41.7758 44.5412 41.3211L54.667 26.7425C54.9158 26.3836 55.1742 25.905 55.5092 25.6274L55.5044 25.6321ZM43.3401 43.2403C43.163 43.3839 42.8041 43.7142 43.1199 43.9008C43.2396 43.7285 43.3736 43.5562 43.4358 43.3552L43.4214 43.2882L43.3401 43.2403Z",
    fill: "url(#paint14_linear_1_259)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8834 21.1475C28.2663 21.1236 30.0416 22.3536 30.4675 22.6121L35.0614 25.4024C37.88 27.1206 37.6694 26.1443 37.6694 29.1164V32.7204C37.9996 32.4141 39.9999 30.5619 40.2774 30.5044C40.6124 30.4326 40.7751 30.8251 40.5885 31.0692C39.8707 31.9786 38.4877 32.6965 37.7029 33.7063L37.6647 33.7542C37.6647 35.0895 37.7269 36.5541 37.6647 37.8703C36.4683 38.7653 34.9944 39.3444 33.7838 40.3016V40.9813C34.2431 41.01 36.6932 40.7037 36.6741 41.345C36.6597 41.8715 34.2766 41.6705 33.7838 41.6753V43.8147H36.2673C36.6358 43.8147 36.9038 44.2406 36.5162 44.4273C36.1668 44.5948 33.5397 44.5469 33.1425 44.3986C32.9942 43.9247 33.0803 41.4407 33.0803 40.7755C32.5156 40.9717 31.8935 41.3977 31.4198 41.7662C31.3911 42.9388 31.4198 44.121 31.4198 45.2984C31.9031 45.8153 32.8554 46.5667 33.1856 47.1219C33.2239 47.9595 33.2143 48.8401 33.1856 49.6777C32.9224 49.9361 30.4388 52.7887 30.4532 51.5491C30.4532 51.1709 32.1615 49.6825 32.5109 49.3426V47.3899C31.9605 46.7438 31.147 46.2317 30.702 45.5185V42.1491C29.7306 42.6373 28.8644 43.3839 27.8739 43.8194C27.4384 43.5897 27.046 43.2882 26.6058 43.068V46.3992C26.6058 49.0076 27.0986 48.6582 24.6055 48.6534C24.5863 51.9798 24.0312 50.4817 22.1028 53.0471L22.0645 53.0998C21.8778 53.2768 21.9831 53.5305 21.8922 53.7411C21.7151 54.1288 21.251 53.8799 21.2318 53.3439C21.2079 52.7121 21.8443 52.2813 22.2415 51.8793L23.9212 50.1515C24.036 47.7584 23.2991 47.9547 25.8927 47.9499C25.9454 46.1694 25.8784 44.3746 25.8927 42.5894C25.3376 42.3022 24.8304 41.8667 24.2322 41.6753C24.2705 43.2068 24.2322 44.748 24.2322 46.2843C24.0552 46.5188 21.83 49.3618 21.6146 48.1653C21.5572 47.8589 23.213 46.38 23.524 45.9971C23.5671 44.3794 23.524 42.7474 23.524 41.1296C22.9928 40.8138 22.4904 40.4452 21.9353 40.1724C21.9353 40.7994 22.0118 44.1497 21.8826 44.4225C21.7773 44.4991 17.6572 44.949 18.4037 43.9343C18.8966 43.7046 20.6002 43.8147 21.2462 43.8099V41.6705H17.5232C16.8293 43.226 15.3554 42.3501 14.7094 41.3259C14.719 40.8855 16.1067 40.0911 16.4848 40.1293C16.9394 40.1724 17.2744 40.651 17.5232 40.9813C18.7626 40.9813 20.0068 40.943 21.2462 40.9813V39.689C17.3653 37.6214 18.1501 37.7123 18.1596 33.3665C17.0877 32.5673 14.1304 30.7437 15.231 30.5475C15.6713 30.4661 17.7577 32.2226 18.1596 32.572C18.1883 31.9642 18.1596 31.3468 18.1596 30.7389V27.2116C18.7099 26.7425 19.399 26.374 20.0116 25.9959L23.2034 24.0336C24.7586 23.0811 26.2612 21.9995 27.8739 21.1523L27.8834 21.1475ZM27.8834 21.875C25.5099 23.464 23.0502 24.9334 20.648 26.4793C20.0738 26.8478 19.4469 27.1493 18.8918 27.5514L18.9636 37.4491C20.3561 38.0713 22.8014 39.8326 24.1939 40.7085L26.8211 42.3405C27.1704 42.5607 27.582 42.7713 27.8786 43.0537C30.5584 41.2014 34.1044 39.1147 36.9229 37.4491V30.7246C36.9229 29.6142 36.9038 28.499 36.9229 27.3839C33.98 25.5508 30.8886 23.598 27.8786 21.8702L27.8834 21.875ZM16.212 40.8664C15.6952 41.1966 15.743 41.9194 16.4848 41.7518C17.1212 41.4838 16.882 40.8377 16.212 40.8664Z",
    fill: "url(#paint15_linear_1_259)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8834 25.4598C28.4912 25.4694 28.6108 25.9863 28.1466 26.2974C27.582 26.307 27.3858 25.7949 27.8834 25.4598Z",
    fill: "url(#paint16_linear_1_259)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8834 27.6663C28.4672 27.6423 28.7113 28.2262 28.1466 28.5325C27.5102 28.5661 27.424 27.9774 27.8834 27.6663Z",
    fill: "url(#paint17_linear_1_259)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2558 30.0593C21.5764 30.0928 26.0698 32.9262 26.467 33.3618C26.467 33.9074 26.5292 37.3247 26.4335 37.5018C26.2612 37.8272 25.821 37.6549 25.7827 37.3247C25.6822 36.4057 25.7396 34.6827 25.7683 33.7494C25.218 33.2947 24.5672 32.8879 23.926 32.5625C23.2321 32.0408 22.4664 31.567 21.7199 31.1218V34.094C22.1458 34.3908 24.0982 35.5682 24.1844 35.8936C24.5146 37.205 21.2893 34.6779 21.0069 34.453C20.9447 33.6824 20.849 30.3991 21.2605 30.0593H21.2558Z",
    fill: "url(#paint18_linear_1_259)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4011 30.0593C35.1236 30.0115 34.8509 31.2271 34.8509 31.6722V34.453C34.626 34.6396 31.2571 37.3486 31.6447 35.908C31.7404 35.549 33.7838 34.3142 34.1474 34.094C34.1666 33.1033 34.1474 32.1126 34.1474 31.1218C33.4918 31.3803 32.8698 31.8541 32.2764 32.237C31.5777 32.6965 30.5824 33.2086 29.9746 33.7494V36.0468C29.9794 36.2334 30.1469 38.3441 29.3382 37.5113C29.0893 37.2529 29.2377 36.2765 29.2377 35.9463V33.3618C29.6827 32.9406 30.5632 32.4715 31.104 32.1221L33.1234 30.849C33.5445 30.581 33.956 30.2891 34.3963 30.0593H34.4011Z",
    fill: "url(#paint19_linear_1_259)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4336 43H93.1953V35.2305L83.1172 26.1953H86.4922L94.3203 33.25L102.148 26.1953H105.512L95.4336 35.2305V43ZM118.203 43H109.238C106.777 43 104.762 40.9844 104.762 38.5234V34.0352C104.762 31.5742 106.777 29.5586 109.238 29.5586H118.203C120.664 29.5586 122.68 31.5742 122.68 34.0352V38.5234C122.68 40.9844 120.664 43 118.203 43ZM118.203 40.7617C119.457 40.7617 120.441 39.7773 120.441 38.5234V34.0352C120.441 32.7812 119.457 31.7969 118.203 31.7969H109.238C107.973 31.7969 107 32.7812 107 34.0352V38.5234C107 39.7773 107.973 40.7617 109.238 40.7617H118.203ZM138.5 43H130.098C127.637 43 125.621 40.9844 125.621 38.5234V29.5586H127.859V38.5234C127.859 39.7773 128.844 40.7617 130.098 40.7617H138.5C139.766 40.7617 140.738 39.7773 140.738 38.5234V29.5586H142.977V38.5234C142.977 40.9844 140.961 43 138.5 43ZM164.047 43H150.605C148.145 43 146.129 40.9844 146.129 38.5234V30.6836C146.129 28.2109 148.145 26.1953 150.605 26.1953H164.047C166.508 26.1953 168.523 28.2109 168.523 30.6836H166.285C166.285 29.418 165.312 28.4453 164.047 28.4453H150.605C149.352 28.4453 148.367 29.418 148.367 30.6836V38.5234C148.367 39.7773 149.352 40.7617 150.605 40.7617H164.047C165.312 40.7617 166.285 39.7773 166.285 38.5234H168.523C168.523 40.9844 166.508 43 164.047 43ZM193.344 43H190.965L187.988 37.3984H173.738V43H171.5V26.1953H188.855C191.316 26.1953 193.332 28.2109 193.332 30.6836V32.9219C193.332 34.8906 192.031 36.5898 190.25 37.1758L193.344 43ZM188.855 35.1602C190.121 35.1602 191.105 34.1758 191.105 32.9219V30.6836C191.105 29.418 190.121 28.4453 188.855 28.4453H173.738V35.1602H188.855ZM220.965 43H218.715V30.0039L209.762 40.3047H207.523L198.559 30.0039V43H196.32V26.1953H198.559L208.637 38.0664L218.715 26.1953H220.965V43Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_259",
    x1: 2.53073,
    y1: 34.3046,
    x2: 237.012,
    y2: 34.3046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#374151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111827"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_259",
    x1: 0.855865,
    y1: -8.23754,
    x2: 238.687,
    y2: -8.23754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#374151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111827"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_259",
    x1: 26.2947,
    y1: 53.4539,
    x2: 27.0317,
    y2: 53.4539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#374151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111827"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_259",
    x1: 37.1143,
    y1: 45.8918,
    x2: 37.8896,
    y2: 45.8918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#374151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111827"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_259",
    x1: 13.9246,
    y1: 14.6575,
    x2: 14.7764,
    y2: 14.6575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#374151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111827"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_259",
    x1: 18.2266,
    y1: 46.0546,
    x2: 19.0928,
    y2: 46.0546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#374151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111827"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_259",
    x1: 11.4027,
    y1: 54.6792,
    x2: 12.2593,
    y2: 54.6792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#374151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111827"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_259",
    x1: 37.5546,
    y1: 41.2732,
    x2: 39.8803,
    y2: 41.2732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#374151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111827"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_259",
    x1: 50.5611,
    y1: 56.8999,
    x2: 57.0979,
    y2: 56.8999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#374151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111827"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_259",
    x1: 26.2564,
    y1: 48.4907,
    x2: 29.0606,
    y2: 48.4907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#374151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111827"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1_259",
    x1: 11.3932,
    y1: 31.2702,
    x2: 12.2163,
    y2: 31.2702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#374151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111827"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1_259",
    x1: 14.4941,
    y1: 53.0663,
    x2: 48.6566,
    y2: 53.0663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#374151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111827"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1_259",
    x1: 16.9011,
    y1: 24.1819,
    x2: 44.9001,
    y2: 24.1819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#374151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111827"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1_259",
    x1: 38.081,
    y1: 35.683,
    x2: 59.9547,
    y2: 35.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#374151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111827"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1_259",
    x1: 42.4356,
    y1: 35.0656,
    x2: 55.9542,
    y2: 35.0656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#374151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111827"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1_259",
    x1: 14.719,
    y1: 37.5305,
    x2: 40.6651,
    y2: 37.5305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#374151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111827"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1_259",
    x1: 27.5963,
    y1: 25.881,
    x2: 28.429,
    y2: 25.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#374151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111827"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1_259",
    x1: 27.5915,
    y1: 28.1018,
    x2: 28.4624,
    y2: 28.1018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#374151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111827"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1_259",
    x1: 20.9447,
    y1: 33.8691,
    x2: 26.4861,
    y2: 33.8691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#374151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111827"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1_259",
    x1: 29.1946,
    y1: 33.8834,
    x2: 34.9035,
    y2: 33.8834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#374151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111827"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoucrm);
export default __webpack_public_path__ + "static/media/youcrm.bdc289c0573ae4ae2d0cca7d8a73f9e4.svg";
export { ForwardRef as ReactComponent };